import { hasPushPermission } from "./hasPushPermission";

export const INSURANCE_CANCEL_PUSH_FUNCTION_KEYS = [
  "cancelamento_seguros",
  "Cancelamento de Seguros",
] as const;

export const INSURANCE_CANCEL_PUSH_LABEL = "Link cancelamento via App";
export const INSURANCE_CANCEL_PUSH_TITLE = "Cancele seu seguro pelo app";
export const INSURANCE_CANCEL_PUSH_DESCRIPTION =
  "Solicite o cancelamento do seu seguro de forma rápida e segura. Acesse o app e conclua o processo com total privacidade. Toque aqui para continuar.";
export const INSURANCE_CANCEL_PUSH_SUCCESS =
  "Link para cancelamento de seguro enviado com sucesso";
export const INSURANCE_CANCEL_PUSH_JOURNEY = "cancelamento_seguros";
export const INSURANCE_CANCEL_PUSH_CONFIRM_TITLE = "Link cancelamento via App";
export const INSURANCE_CANCEL_PUSH_CONFIRM_DESCRIPTION =
  "Deseja enviar o link para cancelamento do seguro pelo aplicativo?";

export type InsuranceCancelActionVisibility = {
  showSacCancelAction: boolean;
  showPushCancelAction: boolean;
};

export function getInsuranceCancelActionVisibility({
  hasCancelInsurancePermission,
  pushChannelEnabled,
  sacChannelEnabled,
}: {
  hasCancelInsurancePermission: boolean;
  pushChannelEnabled: boolean;
  sacChannelEnabled: boolean;
}): InsuranceCancelActionVisibility {
  if (!hasCancelInsurancePermission) {
    return {
      showSacCancelAction: false,
      showPushCancelAction: false,
    };
  }

  return {
    showSacCancelAction: Boolean(sacChannelEnabled),
    showPushCancelAction: Boolean(pushChannelEnabled),
  };
}

const hasInsuranceCancelChannel = (channel: "push" | "sac"): boolean =>
  INSURANCE_CANCEL_PUSH_FUNCTION_KEYS.some((functionKey) =>
    hasPushPermission(functionKey, channel)
  );

export function resolveInsuranceCancelActionVisibility(
  permissions?: string[] | null
): InsuranceCancelActionVisibility {
  return getInsuranceCancelActionVisibility({
    hasCancelInsurancePermission: Boolean(
      permissions?.includes("cancel_insurance")
    ),
    pushChannelEnabled: hasInsuranceCancelChannel("push"),
    sacChannelEnabled: hasInsuranceCancelChannel("sac"),
  });
}
